import { render, staticRenderFns } from "./PropCategory.vue?vue&type=template&id=1c8dc016&"
import script from "./PropCategory.vue?vue&type=script&lang=js&"
export * from "./PropCategory.vue?vue&type=script&lang=js&"
import style0 from "./PropCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports